/**
 * Silber Hero Slideshow Component
 */

if (!customElements.get('slideshow-component')) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.silber-hero__slide');
      this.dots = this.querySelectorAll('.silber-hero__dot');
      this.prevButton = this.querySelector('.silber-hero__arrow--prev');
      this.nextButton = this.querySelector('.silber-hero__arrow--next');
      this.currentIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed) || 5000;
      this.autoplayInterval = null;
      this.isHovered = false;
    }

    connectedCallback() {
      if (this.slides.length <= 1) return;

      this.bindEvents();
      
      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    bindEvents() {
      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Arrow navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      // Pause on hover
      this.addEventListener('mouseenter', () => {
        this.isHovered = true;
        this.stopAutoplay();
      });

      this.addEventListener('mouseleave', () => {
        this.isHovered = false;
        if (this.autoplay) {
          this.startAutoplay();
        }
      });

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.prevSlide();
        } else if (e.key === 'ArrowRight') {
          this.nextSlide();
        }
      });

      // Touch swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });
    }

    handleSwipe(startX, endX) {
      const threshold = 50;
      const diff = startX - endX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      // Remove active state from current slide
      this.slides[this.currentIndex].classList.remove('silber-hero__slide--active');
      this.dots[this.currentIndex].classList.remove('silber-hero__dot--active');

      // Update current index
      this.currentIndex = index;

      // Add active state to new slide
      this.slides[this.currentIndex].classList.add('silber-hero__slide--active');
      this.dots[this.currentIndex].classList.add('silber-hero__dot--active');

      // Reset autoplay timer
      if (this.autoplay && !this.isHovered) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      if (this.autoplayInterval) return;
      
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, this.speed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  customElements.define('slideshow-component', SlideshowComponent);
}
